import './rxjs-operators';
var AppComponent = /** @class */ (function () {
    function AppComponent() {
    }
    return AppComponent;
}());
export { AppComponent };
//# sourceMappingURL=app.component.js.map